<template>
  <div>
    <template v-if="isHomeSection">
      <Home />
    </template>

    <div v-else class="d-flex flex-column align-center mt-12">
      <div class="full-width px-16">
        <Alerts />
      </div>

      <template v-if="isOffersSection">
        <Offers />
      </template>

      <template v-else-if="isModelsSection">
        <RateModels />
      </template>

      <template v-else-if="isTranslationsSection">
        <Translations />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ADMIN_SECTIONS } from '@/helpers/constants'
import Alerts from '@/components/Alerts'
import Home from '@/containers/admin/Home'
import Offers from '@/containers/admin/Offers'
import RateModels from '@/containers/admin/RateModels'
import Translations from '@/containers/admin/Translations'

export default {
  name: 'Admin',
  components: {
    Alerts,
    Home,
    Offers,
    RateModels,
    Translations,
  },
  computed: {
      ...mapState('process', ['adminDisplay']),
    isHomeSection() {
      return this.adminDisplay === ADMIN_SECTIONS.HOME
    },
    isOffersSection() {
      return this.adminDisplay === ADMIN_SECTIONS.OFFERS
    },
    isModelsSection() {
      return this.adminDisplay === ADMIN_SECTIONS.MODELS
    },
    isTranslationsSection() {
      return this.adminDisplay === ADMIN_SECTIONS.TRANSLATIONS
    },
  },
}
</script>
